module.exports = __webpack_public_path__ + "img/google_translate.24428035.png";